import React from 'react';
import classNames from 'classnames/bind';
import styles from './PageSimpleHeading.module.scss';

const cx = classNames.bind(styles);

function PageSimpleHeading({ title, description = undefined, style = undefined }) {
	return (
		<div
			className={cx('title_wrap')}
			style={style}
		>
			<h3 className={cx('title')}>{title}</h3>
			{description && <p className={cx('description')}>{description}</p>}
		</div>
	);
}

export default PageSimpleHeading;
